import React from "react";

const InvoiceData = (item, index) => {
  return (
    <div>
      <div
        key={index}
        className="measure-row py-2 px-4  text-xs box-border border-b border-gray-100"
      >
        <div className="grid grid-cols-13 gap-4">
          <div className="col-span-1 text-center ">{index + 1}</div>
          <div className="col-span-4">{item.item}</div>
          <div className="col-span-4">{item.description}</div>
          <div className="col-span-1  text-center">{item.quantity}</div>
          <div className="col-span-1">${item.price.toFixed(2)}</div>
          <div className="col-span-2 text-right ">
            ${(item.quantity * item.price - (item.discount || 0)).toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceData;
